'use client'

import dynamic from 'next/dynamic'

const Sidebar = dynamic(() => import('./Sidebar'), { ssr: false })

export default Sidebar
